import React from 'react';
import withAuth from '../../withAuth';
import { Alert, AlertTitle, Box, Button, Container } from '@mui/material';
import { useVerifyEmail } from '../../hooks/useVerifyEmail';
import { featureFlags } from '../../utils/featureFlags';

const VerifyEmail: React.FC = () => {
  const {
    disabledSubmit,
    error,
    userEmail,
    handleResendVerificationEmail,
    handleBackAction,
    handleDeleteAccount,
  } = useVerifyEmail();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: 3,
        }}
      >
        <Alert
          color="warning"
          severity="warning"
          action={
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              onClick={handleResendVerificationEmail}
              disabled={disabledSubmit}
              data-testid="verify-email-resend-button"
            >
              Resend
            </Button>
          }
          data-testid="verify-email-alert"
        >
          <AlertTitle>Verify Email</AlertTitle>
          Email <strong>{userEmail}</strong> is not
          verified, check your inbox for a verification email, or click 'Resend"
          for a new one.
          {error && <div style={{ color: 'red', marginTop: '5px' }}>{error}</div>}
        </Alert>
      </Box>
      <Button
        sx={{
          marginTop: 3,
          boxShadow: 3,
        }}
        variant="contained"
        color="primary"
        size="small"
        onClick={handleBackAction}
      >
        Back to Login
      </Button>
      {featureFlags.showDeleteAccountButton && (
        <Button
          sx={{
            marginTop: 3,
            marginLeft: 2,
            boxShadow: 3,
            backgroundColor: '#d32f2f',
            color: 'white',
            '&:hover': {
              backgroundColor: '#b71c1c',
            },
          }}
          variant="contained"
          size="small"
          onClick={handleDeleteAccount}
          data-testid="verify-email-delete-button"
        >
          Delete Account
        </Button>
      )}
    </Container>
  );
};

export default withAuth(VerifyEmail);
